import '@/styles/components/modal/modal.scss';
import '@/styles/components/modal/slide-animation.scss';
import '@/styles/components/modal/base-modal.scss';
import '@/styles/components/btn.scss';